import * as bi from 'react-bootstrap-icons';
import { IClientPassengerBrief } from '@bustickus/models-client';
import { Box, Button, Flex, Header } from 'components';
import { PassengerCard } from '..';

interface IProps {
  onAddClick: () => void;
  onRemoveClick: (passenger: IClientPassengerBrief) => void;
  passengers: IClientPassengerBrief[];
}

function PassengerList(props: IProps) {
  return (
    <Box padding={20}>
      <Flex
        direction='column'
        gap={20}
      >
        <Header>Список пассажиров</Header>
        {props.passengers.length > 0 && (
          <Flex
            direction='column'
            gap={10}
          >
            {props.passengers.map((x) => (
              <PassengerCard
                key={x.id}
                passenger={x}
                onClick={() => props.onRemoveClick(x)}
              />
            ))}
          </Flex>
        )}
        <Button
          color='transparent-red'
          onClick={props.onAddClick}
        >
          <Flex
            gap={5}
            justifyContent='center'
            alignItems='center'
          >
            <bi.PersonAdd />
            <span>Добавить пассажира</span>
          </Flex>
        </Button>
      </Flex>
    </Box>
  );
}

export default PassengerList;
